var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.current_acount_payment_methods.length)?_c('b-button',{staticClass:"m-r-15",attrs:{"variant":"primary"},on:{"click":_vm.showPaymentMethods}},[_vm._v(" Met Pago "),(_vm.model.is_provisorio)?_c('b-badge',[_vm._v(" (Provisorio) ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }